import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { fpaMonitoringAction } from '../actions/actionTypes';

const insertUpdateData = (action) => ({
  listData: action.data,
  listRequestError: null,
  listRequestProcessedOn: new Date(),
  loading: false,
});

const FpaMonitoring = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // reset Upset Value
    case fpaMonitoringAction.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        dataRequestError: action.data.dataRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
        loading: false,
      };
    // reset Delete Value
    case fpaMonitoringAction.RESET_DELETE_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case fpaMonitoringAction.UPDATE_FPA_RESPONSE:
      return {
        ...state,
        ...insertUpdateData(action),
      };
    // Configure Page Details
    case fpaMonitoringAction.SET_FPA_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case fpaMonitoringAction.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    case fpaMonitoringAction.RESET_SERVER_VALUE:
      return {
        ...state,
        serverRequestError: action.data && action.data.serverRequestError,
      };
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default FpaMonitoring;
